import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { LandingPage } from './LandingPage';
import { Spinner } from '../components/ui';

/**
 * What "/" means depends on who is asking.
 *
 * The landing page sells the product. Someone who already signed up has bought
 * it, and showing them the pitch every time they open the site puts an advert
 * between them and their own trips. So the front door goes to the dashboard for
 * anyone signed in, and stays a landing page for everyone else.
 *
 * The wait matters: session restore is a round trip, and rendering the landing
 * first would flash the pitch at a signed-in user before redirecting them.
 */
export function HomeRoute() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="grid min-h-[60vh] place-items-center">
        <Spinner className="size-8 text-clay-500" />
      </div>
    );
  }

  return status === 'authenticated' ? <Navigate to="/app" replace /> : <LandingPage />;
}
